import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/common";
import Layout from "@/components/Layout";
import Prefetcher from "@/components/Prefetcher";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Characters from "@/pages/Characters";
import CharacterSheet from "@/pages/CharacterSheet";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Spells from "@/pages/Spells";
import Items from "@/pages/Items";
import DiceRoller from "@/pages/DiceRoller";
import DMView from "@/pages/DMView";
import Rules from "@/pages/Rules";
import Settings from "@/pages/Settings";
import Bestiary from "@/pages/Bestiary";
import Compendium from "@/pages/Compendium";
import AdminPage from "@/pages/AdminPage";

function Protected({ children }) {
  const { user, booting } = useAuth();
  if (booting || user === null) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout><Prefetcher />{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, booting } = useAuth();
  if (booting || user === null) return <PageLoader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/characters" element={<Protected><Characters /></Protected>} />
      <Route path="/characters/:id" element={<Protected><CharacterSheet /></Protected>} />
      <Route path="/campaigns" element={<Protected><Campaigns /></Protected>} />
      <Route path="/campaigns/:id" element={<Protected><CampaignDetail /></Protected>} />
      <Route path="/spells" element={<Protected><Spells /></Protected>} />
      <Route path="/items" element={<Protected><Items /></Protected>} />
      <Route path="/bestiary" element={<Protected><Bestiary /></Protected>} />
      <Route path="/compendium" element={<Protected><Compendium /></Protected>} />
      <Route path="/dice" element={<Protected><DiceRoller /></Protected>} />
      <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
      <Route path="/dm" element={<Protected><DMView /></Protected>} />
      <Route path="/rules" element={<Protected><Rules /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="bottom-right" richColors />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
